<template>
  <v-container
    fluid
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-monitor-lock
      </v-icon> Digi-Board Licence
    </h2>
    <v-card
      color="#CFD8DC"
      shaped
    >
      <v-container
        fluid
      >
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-card
              color="#eceff1"
              class="licence-content-style"
            >
              <v-container fluid>
                <p
                  v-if="!showLicenceContent"
                  class="licence-alert-color"
                >
                  <br>
                  No licence found for this digi-board.
                </p>
                <br>
                <div v-if="showLicenceContent">
                  <p class="my-p-style">
                    Status:
                    <font
                      :color="getColor(digiBoardLicenceContent.active)"
                      bold
                    >
                      {{ digiBoardLicenceContent.active | statusUpdate }}
                    </font>
                  </p>
                  <p class="my-p-style">
                    Licence Key:-
                    <font class="font-my-style">
                      {{ digiBoardLicenceContent.licence_key }}
                    </font>
                  </p>
                  <p class="my-p-style">
                    Licence Active From:-
                    <font class="font-my-style">
                      {{ digiBoardLicenceContent.start | convertStringToLocalDatetime }}
                    </font>
                  </p>
                  <p class="my-p-style">
                    Licence Active To:-
                    <font class="font-my-style">
                      {{ digiBoardLicenceContent.end | convertStringToLocalDatetime }}
                    </font>
                  </p>
                </div>
              </v-container>
              <v-col
                class="text-right cancel-btn-style"
              >
                <v-btn
                  v-if="showCancelButton"
                  color="red darken-3"
                  @click="cancelLicence(digiBoardLicenceContent.id)"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-card>
          </v-col>
        </v-row>
        <centre-spinner
          :loading="loading"
        />
      </v-container>
    </v-card>
    <delete-licence
      v-if="showDelete"
      :title="'Cancel Licence?'"
      :message="'This action will cancel your licence subscription.'"
      @closed="showDelete = false"
      @confirmed="deleteConfirmed()"
    />
  </v-container>
</template>
 <script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';

  export default {
    name: 'DigiBoardLicenceDetails',
    components: {
      'centre-spinner': spinner,
      'delete-licence': DeleteDialog,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (warranty) {
        if (warranty === true) return 'Active*';
        else return 'Inactive';
      },
    },
    data () {
      return {
        loading: false,
        showDelete: false,
        licenceId: '',
      };
    },
    computed: {
      digiBoardLicenceContent () {
        return this.$store.getters['digiboards/getDigiBoardLicenceContent'];
      },
      showLicenceContent () {
        return Object.keys(this.digiBoardLicenceContent).length > 0;
      },
      showCancelButton () {
        return this.digiBoardLicenceContent.active === true;
      },
    },
    async mounted () {
      await this.fillData();
    },
    methods: {
      async fillData () {
        this.loading = true;
        const digiBoardId = this.$route.params.id;
        await this.$store.dispatch('digiboards/fetchDigiBoardLicenceContent', {
          params: {
            digiBoardId: digiBoardId,
          },
        }).then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      cancelLicence (boardId) {
        this.showDelete = true;
        this.licenceId = boardId;
      },
      async deleteConfirmed () {
        this.loading = true;
        await this.$store.dispatch('digiboards/deleteLicence', this.licenceId)
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Licence deleted.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
          }).finally(
            this.loading = false,
            this.showDelete = false,
            this.licenceId = '',
            this.fillData(),
          );
      },
      getColor (active) {
        if (active === true) return '#2E7D32';
        else return '#C62828';
      },
    },
  };
</script>
<style scoped>
.licence-alert-color {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
}
.my-p-style {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  margin-bottom: 5px;
}
.licence-content-style {
  border-left: 3px solid #FF3700 !important;
}
.cancel-btn-style {
  padding-top: 40px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-title-style {
  color: #546e7a;
}
@media (max-width: 600px) {
  .my-btn-style {
    margin-top: 0px;
  }
 .cancel-btn-style {
    padding-top: 12px;
  }
}
@media (max-width: 960px) {
  .title-style {
    margin-top: -20px;
  }
}
</style>
